import axios from 'axios';

import ApiClientWellFunnel from 'services/api/ApiClientWellFunnel';
import ApiClientMobile from 'services/api/ApiClientMobile';

import {
    IGetAccessCodeResponse,
    IGetAccessTokenRequest,
    IGetAccessTokenResponse,
    IGetAuthTokenResponse,
    IGetTokenByCWTData,
    IGetTokenWFResponse,
    IRotatedAuthTokensResponse,
    SendTemporaryPasswordRequest,
    SignInRequest,
} from './types';

class AuthApi {
    signIn = async <Data = SignInRequest, Response = IRotatedAuthTokensResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await ApiClientMobile.post<Data, Response>('auth/sign-in-with-access-code', payload);
    };

    sendTemporaryPassword = async <Data = SendTemporaryPasswordRequest>(payload: Data): Promise<void> => {
        return await ApiClientMobile.post<Data>('auth/send-access-code', payload);
    };

    getTokenWF = async <Response = IGetTokenWFResponse>(): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.get<Response>('auth/token-web');
    };

    getMobileToken = async <Response = IRotatedAuthTokensResponse>(): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.get<Response>('auth/token-core');
    };

    getAccessToken = async <Data = IGetAccessTokenRequest, Response = IGetAccessTokenResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return axios.post(`${import.meta.env.MOBILE_API_URL}/auth/token/refresh`, payload, {
            headers: { 'x-api-key': import.meta.env.MOBILE_API_KEY },
        });
    };

    getTokenByCWT = async <Data = IGetTokenByCWTData, Response = IRotatedAuthTokensResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await ApiClientMobile.post<Data, Response>('auth/token/exchange', payload);
    };

    getAppAccessCode = async <Response = IGetAccessCodeResponse>(): Promise<Partial<Response>> => {
        return await ApiClientMobile.get<Response>('auth/user/access-code');
    };

    getAuthToken = async <Response = IGetAuthTokenResponse>(): Promise<Partial<Response> | unknown> => {
        return await ApiClientMobile.get<Response>('/auth/token');
    };
}

export default AuthApi;
